<div class="loader coin-loader">
  <img src="/assets/images/coins-2.png" />
</div>